import React from "react";
import { useParams } from "react-router-dom";
import { MessageSquareText } from "lucide-react";

import TicketsManager from "../../components/TicketsManager/";
import Ticket from "../../components/Ticket/";

import { i18n } from "../../translate/i18n";

const Chat = () => {
  const { ticketId } = useParams();

  return (
    <div className="flex h-full min-h-0 flex-1 overflow-hidden">
      <div
        className={`h-full w-full shrink-0 overflow-hidden border-r sm:w-[380px] ${
          ticketId ? "hidden sm:block" : "block"
        }`}
      >
        <TicketsManager />
      </div>
      {/* Uma conversa só, nunca duas.
          Antes havia uma cópia para desktop e outra para celular, e com um
          atendimento aberto as DUAS montavam: dois sockets na mesma sala,
          duas buscas do ticket e duas da lista de mensagens a cada abertura.
          Quem decide onde ela aparece é o CSS, não um segundo <Ticket/>.

          min-w-0: item flex nasce com min-width:auto e se recusa a encolher
          além do conteúdo. Sem isso a conversa estica até a largura da maior
          mensagem e vaza para fora da tela — no celular os balões apareciam
          cortados pela direita, com o texto inalcançável. */}
      <div
        className={`min-h-0 min-w-0 flex-1 ${
          ticketId ? "flex" : "hidden sm:flex"
        }`}
      >
        {ticketId ? (
          <Ticket />
        ) : (
          <div className="flex h-full w-full flex-col items-center justify-center gap-3 bg-muted/30 text-center">
            <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-primary/10 text-primary">
              <MessageSquareText className="h-7 w-7" />
            </div>
            <span className="max-w-xs text-sm text-muted-foreground">
              {i18n.t("chat.noTicketMessage")}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default Chat;
